// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T8no","col":"styles_col__3ko-U"};